import { createPlatformAuthClient, resolveAuthBaseUrl } from "./create-client";

import { env } from "@platform/core/env";
import { pageSession } from "@platform/core/page-session";

export const authClient = createPlatformAuthClient({
	baseURL: resolveAuthBaseUrl(env.API_BASE_URL, globalThis.location?.origin),
	sessionBinding: pageSession,
});

// The MCP approval page checks each OAuth redirect against the signed request before it leaves.
export const connectAuthClient = createPlatformAuthClient({
	baseURL: resolveAuthBaseUrl(env.API_BASE_URL, globalThis.location?.origin),
	sessionBinding: pageSession,
	followRedirects: false,
});

export const { useListOrganizations } = authClient;
